//* ACTIONTYPES --------------------------------------------
export const POST_TEMPORAL_DP_LOADING = 'POST_TEMPORAL_DP_LOADING';
export const POST_TEMPORAL_DP_SUCCESS = 'POST_TEMPORAL_DP_SUCCESS';
export const POST_TEMPORAL_DP_REJECT = 'POST_TEMPORAL_DP_REJECT';

//* ACTIONS ------------------------------------------------
export const postTemporalDPLoading = () => ({ type: POST_TEMPORAL_DP_LOADING });
export const postTemporalDPSuccess = (payload) => ({ type: POST_TEMPORAL_DP_SUCCESS, payload });
export const postTemporalDPReject = (payload) => ({ type: POST_TEMPORAL_DP_REJECT, payload });
